export default __webpack_public_path__ + "static/media/watch-1.434a9389.png";